import { Component, Mixins } from 'vue-property-decorator';
import { RouteName } from '../../routes/routes.constants';
import { MagicConfigMixin } from '@gig/magic-common';
import { MetaMixin } from '../../mixins/meta.mixin';
import {
    IMetaTag,
    meta,
    MetaTag,
} from '@gig/magic-frontend-toolkit/dist/services/meta';
import { setPrerenderReady } from '../../services/seo/prerender.service';

const NotFoundMeta: IMetaTag = {
    name: MetaTag.PRERENDER_STATUS_CODE,
    content: RouteName.PAGE404,
};

@Component
export default class NotFound extends Mixins(MetaMixin, MagicConfigMixin) {
    RouteName = RouteName;

    created() {
        meta.setMetaTag(NotFoundMeta);
        setPrerenderReady();
    }
}
